export class OcLog {
    tm: number;
    seq: number;
    date: string;
    time: string;
    type: string;
    evnr_type: number;
    user_name: string;
    name: string;
    user_field: string;

    constructor() {
        this.tm = 0; 
        this.seq = 0; 
        this.date = '';
        this.time =  '';
        this.type = '';
        this.evnr_type = 0; 
        this.user_name =  '';
        this.name =  '';
        this.user_field = '';
    }
}